import React, { useEffect, useState, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import Select from 'react-select';
import lodash from 'lodash';
import { CSVLink } from 'react-csv';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';

import { detectIconById } from '../../../common/enum'
import {
    getCustomeLeaderBoard, getYear, getYearSeasonRanges,
    getReports, getTeams, saveCustom,
    getReport, getReportConfig,
    getPlayerDetail, resetTableList,
    updateCustom, updateCustomList,
} from './../../../actions/leader-board';
import Loading from '../../../components/loading';
import Dropdown from '../../../components/dropdown';
import { getColorWithRank } from '../../../common/getColorWithRank';
import { createOrRemove, fileNameCSV } from '../../../common/helper';
import NewCustomReportModal from './NewCustomReportModal';
import KeywordSearch from './KeywordSearch';
import SwapItemModal from './SwapItemModal';
import FilterModal from './FilterModal';
import CustomListModal from "./CustomListModal";

import './style.scss';

const NEW_CUSTOM_REPORT_MODAL = 'new-custom-report-modal';
const EDIT_CUSTOM_REPORT_MODAL = 'edit-custom-report-modal';
const FILTER_MODAL = 'filter-modal';
const SWAP_ITEM_MODAL = 'swap-item-modal';


const DropdownIndicator = () => {
    return <img src="/img/ic_arrow_down1.svg" alt="img" />
};

function LeaderBoard() {
    const history = useHistory();
    const [individual, setIndividual] = useState(true);
    const [performance, setPerformance] = useState('pitcher');
    const [isLoadInitStore, setIsLoadInitStore] = useState(false);
    const [modal, setModal] = useState('');
    const [selectedCustom, setSelectedCustom] = useState({ id: null, name: '新規カスタムレポート', columns: [], filters: [] });
    const [selectedYear, setSelectedYear] = useState();
    const [selectedTeam, setSelectedTeam] = useState([{ id: null, team_name: 'NPB' }]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [customError, setCustomError] = useState('');
    const [sortByFields, setSortByFields] = useState({});
    const [displayedCustom, setDisplayedCustom] = useState({});

    //Selector from store
    const tableList = useSelector((state) => state.leaderBoard.tableList, shallowEqual);
    const customReports = useSelector((state) => state.leaderBoard.customReports, shallowEqual);
    const years = useSelector((state) => state.leaderBoard.years, shallowEqual);
    const reports = useSelector((state) => state.leaderBoard.reports, shallowEqual);
    const teams = useSelector((state) => lodash.concat([{ id: null, team_name: 'NPB' }], state.leaderBoard.teams), shallowEqual);
    const columns = useSelector((state) => state.leaderBoard.columns.map(item => {
        return { name: item.name, column: item.column }
    }), shallowEqual);
    const filters = useSelector((state) => state.leaderBoard.filters, shallowEqual);

    const dispatch = useDispatch();

    const fetchReport = useCallback((params) => {
        const { team_ids = [], player_ids = [], year_id = null, report_id = null, columns = [], filters = [], sortField = {} } = params;
        if (!report_id) return;
        const stateOrder = sortField.order === 'asc' ? 'desc' : 'asc';
        dispatch(getReport(report_id, {
            year_id: year_id,
            team_ids: team_ids,
            player_ids: player_ids,
            columns: lodash.isArray(columns) ? lodash.map(columns, 'column') : null,
            filters: lodash.isArray(filters) ? filters.map(item => `${item.column}:${lodash.isObject(item.data) ? item.data.value : item.data}`) : null,
            order: sortField.order,
            sort: sortField.field,
        }));
        if (sortField.field) {
            setSortByFields(prevState => ({ ...prevState, [sortField.field]: stateOrder, activeColumn: sortField.field }));
        }
    }, [sortByFields]);

    const reportsFilter = useMemo(() => {
        const fieldName = individual ? 'player' : 'team';
        return reports[fieldName][performance] || [];
    }, [reports, individual, performance]);

    const resetDefault = useCallback(() => {
        setSelectedTeam([{ id: null, team_name: 'NPB' }]);
        setSelectedPlayers([]);
        setSelectedYear(lodash.head(years));
        setSelectedReport(null);
    }, []);

    const fillDataDropdown = useCallback(async (selectedCustom) => {
        const reportField = selectedCustom.isIndividual ? 'player' : 'team';
        const isPitcher = reports[reportField].pitcher.find((item) => item.id === selectedCustom.report_id) || false;
        const isBatter = reports[reportField].batter.find((item) => item.id === selectedCustom.report_id) || false;
        const isFielder = reports[reportField].fielder.find((item) => item.id === selectedCustom.report_id) || false;

        setIndividual(selectedCustom.isIndividual);
        setPerformance(isPitcher ? 'pitcher' : isBatter ? 'batter' : isFielder ? 'fielder' : 'winloss');

        const findDataReport = reports[reportField][performance].find(report => report.id === selectedCustom.report_id) || null;

        setSelectedReport(findDataReport);

        if (years.length > 0) {
            const findDataYear = years.find(year => year.id === selectedCustom.year_id) || years[0];
            setSelectedYear(findDataYear);
        }

        if (selectedCustom.team_ids) {
            let teamsSelect = [];
            teams.forEach(team => {
                const teamIds = selectedCustom.team_ids || [];
                const findData = teamIds.find(teamId => teamId === team.id);
                if (findData) {
                    teamsSelect.push(team);
                }
            });
            setSelectedTeam(teamsSelect || [{ id: null, team_name: 'NPB' }]);
        }
        if (selectedCustom.isIndividual) {
            setSelectedPlayers([]);
        }
        if (selectedCustom.isIndividual && selectedCustom.player_ids) {
            const players = await dispatch(getPlayerDetail(selectedCustom.player_ids));
            setSelectedPlayers(players);
        }
    }, [years, teams, reports]);

    const onNewCustomReport = useCallback(async () => {
        if (!displayedCustom) return;

        if (displayedCustom.id) {
            await dispatch(updateCustom(displayedCustom));
            toast.success('保存成功');
            dispatch(getCustomeLeaderBoard());
            return;
        }
        setModal(NEW_CUSTOM_REPORT_MODAL);
    }, [displayedCustom]);

    const onOpenFilter = useCallback(() => {
        if (!displayedCustom) return;
        setModal(FILTER_MODAL);
    }, [displayedCustom]);

    const onOpenSwapItem = useCallback(() => {
        if (!displayedCustom) return;
        setModal(SWAP_ITEM_MODAL);
    }, [displayedCustom]);

    const onEditCustomReport = useCallback(() => {
        setModal(EDIT_CUSTOM_REPORT_MODAL);
    }, []);

    const onCloseModal = useCallback(() => {
        setModal('');
        setCustomError('');
    }, []);

    const onChooseIndividual = useCallback(() => {
        setIndividual(true);
        setSelectedReport(null);
    }, []);

    const onChooseTeam = useCallback(() => {
        setIndividual(false);
        setPerformance('pitcher');
        setSelectedReport(null);
    }, []);

    const onChoosePitcher = useCallback(() => {
        setPerformance('pitcher');
        setSelectedReport(null);
    }, []);

    const onChooseBatter = useCallback(() => {
        setPerformance('batter');
        setSelectedReport(null);
    }, []);

    const onChooseFielder = useCallback(() => {
        setPerformance('fielder');
        setSelectedReport(null);
    }, []);

    const onChooseWinloss = useCallback(() => {
        setPerformance('winloss');
        setSelectedReport(null);
    }, []);

    const onSelectCustomReport = useCallback((value) => {
        const isIndividual = !![...reports.player.pitcher, ...reports.player.batter, ...reports.player.fielder].find((item) => item.id === value.report_id) || false;
        const report = [...reports.player.pitcher, ...reports.player.batter, ...reports.player.fielder, ...reports.team.pitcher, ...reports.team.batter, ...reports.team.fielder, ...reports.team.winloss].find(report => report.id === value.report_id) || null;
        const params = {
            ...value,
            isIndividual: isIndividual,
            reportName: report ? report.name : '',
            isShow: true,
        };

        setSelectedCustom(params);
        setIndividual(true);
        setPerformance('pitcher');
        if (value.id === null) {
            resetDefault();
            value["year_id"] = years[0].id;
            return;
        }
        dispatch(getReportConfig(value.report_id));
        fillDataDropdown(params);
    }, [teams, years, reportsFilter]);

    const onSelectYear = useCallback((value) => {
        setSelectedYear(value);
        setSelectedCustom({
            ...selectedCustom,
            year_id: value.id,
        });
    }, [selectedCustom]);

    const onSortList = useCallback((field) => {
        let dataSort = { field: field.column, order: field.default_sort };
        if (!sortByFields[field.column]) {
            fetchReport({
                ...displayedCustom,
                sortField: dataSort,
            });
            return;
        }
        fetchReport({
            ...displayedCustom,
            sortField: { field: field.column, order: sortByFields[field.column] },
        });
    }, [displayedCustom, sortByFields]);

    const onSelectTeam = useCallback((value) => {
        const list = createOrRemove(selectedTeam, value);
        setSelectedTeam(list);
        let teamIds = [];
        list.forEach(team => {
            if (!team.id) return;
            teamIds = lodash.union([...teamIds, ...team.ids]);
        });
        setSelectedCustom({
            ...selectedCustom,
            team_ids: teamIds,
        });
    }, [selectedTeam, selectedCustom]);
    const onSelectReportId = useCallback(async (value) => {
        setSelectedReport(value);
        setSelectedCustom({
            ...selectedCustom,
            reportName: value.name,
            report_id: value.id,
        });
    }, [selectedCustom]);

    const onSelectReport = useCallback(async () => {
        try {
            if (!selectedCustom || !selectedCustom.report_id || !selectedReport) {
                toast.error('未選択項目があります');
                return;
            }
            const reportConfig = await dispatch(getReportConfig(selectedCustom.report_id));
            const columns = reportConfig.columns.map(item => {
                return {
                    name: item.name,
                    column: item.column,
                }
            });
            const defaultFilters = reportConfig.filters.reduce((acc, cur, idx, arr) => {
                if (!cur.default) return acc;
                cur.data = cur.values.reduce((valAcc, valCur, valIdx, valArr) => {
                    return (cur.default === valCur.value) ? valCur : valAcc;
                }, {});
                return [...acc, cur];
            }, []);

            setSortByFields({});

            setSelectedCustom({
                ...selectedCustom,
                columns,
                filters: defaultFilters,
                isIndividual: individual,
                isShow: true,
            });
        } catch (e) {
            toast.error('何かが間違っていました。もう一度やり直してください');
        }
    });

    const onAddPlayer = useCallback((players) => {
        setSelectedPlayers(players);
        setSelectedCustom({
            ...selectedCustom,
            player_ids: players.map(item => item.id)
        });
    }, [selectedCustom]);

    const onSaveFilter = useCallback((list) => {
        setDisplayedCustom({
            ...displayedCustom,
            filters: list,
        });
        onCloseModal();
    }, [displayedCustom]);

    const onRedirectDetail = useCallback((url) => {
        history.push(url)
    }, []);

    const onSaveListCustom = useCallback(async (list) => {
        try {
            await dispatch(updateCustomList(list));
            dispatch(getCustomeLeaderBoard());
            onCloseModal();
            const findData = list.find(item => item.id === selectedCustom.id);
            if (!findData) {
                return;
            }
            setSelectedCustom(findData);
        } catch (e) {
            toast.error('何かが間違っていました。もう一度やり直してください');
        }
    }, [displayedCustom]);

    const onCustomReportSave = useCallback(async (value) => {
        try {
            setCustomError('');
            await dispatch(saveCustom({
                name: value,
                reportId: displayedCustom.report_id,
                yearId: displayedCustom.year_id,
                teamIds: displayedCustom.team_ids,
                playerIds: displayedCustom.player_ids,
                columns: displayedCustom.columns || [],
                filters: displayedCustom.filters || [],
            }));
            dispatch(getCustomeLeaderBoard());
            onCloseModal();
        } catch (error) {
            setCustomError('表を作成してください。');
        }
    }, [displayedCustom]);
    const onConfirmSwapModal = useCallback((list) => {
        setDisplayedCustom({
            ...selectedCustom,
            columns: list,
        });
        onCloseModal();
    }, [displayedCustom]);

    const titleTable = useMemo(() => {
        if (!displayedCustom) return '';
        return displayedCustom.reportName;
    }, [displayedCustom]);

    const fileName = useMemo(() => {
        return fileNameCSV();
    }, []);

    const largeHeadersCSV = useMemo(() => {
        const list = ['', ''];
        let idx = 2;
        tableList.headers.forEach((header, index) => {
            // console.log('list',list);
            // console.log('header.name', header.name, index, list[index], 'length', list.length)
            // for( let i = 0; i <= list.length; i++){
            //     console.log(i, 'list[i]',list[i]);
            //     if(list[i] === '打数'){
            //         list[i] ='';
            //     }
            // }

            list.push(header.name);
            if (header.children && header.children.length) {
                for (let i = 0; i < header.children.length - 1; i++) {
                    list.push(' ');
                }
                idx += header.children.length;
            } else {
                list[idx] = "";
            }
            // if(index === 0) return;
            // for (let i = 0; i < tableList.size - 1; i++) {
            //     list.push('');
            // }

        });
        return list;
    }, [tableList.headers]);

    const subHeadersCSV = useMemo(() => {
        let list = ['順位'];

        tableList.headers.forEach((header, i) => {
            if (displayedCustom.isIndividual === false && i === 0) {
                list.push('チーム')
            } else if (displayedCustom.isIndividual === true && i === 0) {
                list.push('選手')
            }
            if (!header.children) {
                list.push(header.name);
                return;
            }
            header.children.forEach(children => {
                list.push(children.name)
            });
        });
        return list;
    }, [tableList.headers, displayedCustom]);

    const listCSV = useMemo(() => {
        const list = [];
        tableList.list.forEach(item => {
            const name = displayedCustom.isIndividual ? item.player.player_name : item.team.team_name;
            const lst = [
                item.rank,
                name,
            ];
            item.data.forEach(value => {
                value.forEach(subValue => {
                    lst.push(subValue.value);
                });
            });
            list.push(lst);
        });
        return list;
    }, [tableList.list, displayedCustom]);

    const renderTableContent = useCallback(() => {
        if (!displayedCustom.report_id || tableList.headers.length === 0) return null;

        return <div className="content-table-leader">
            <div className="table-head" id="table-sticky" >
                <h4>
                    {titleTable}
                </h4>
                <div className="explain-text">
                    {tableList.updatedDateText || ''}
                </div>
                {displayedCustom.report_id === 4 && <div className='explain-text'>※救援防御率はNPB BISと異なり、チーム非自責点を含む</div>}
                {[29, 49].includes(displayedCustom.report_id) && <div className='explain-text'>※送りバント...無死または1死で、走者がいる状況でのバント。成功にバント安打を含む</div>}

                <div className="group-btn-head">
                    <div className='cursor-poiter' onClick={onOpenFilter}>
                        <img alt='list' src="/img/ic_list_leader_board.svg" />
                        <span>絞り込み</span>
                    </div>
                    <div className='cursor-poiter' onClick={onOpenSwapItem} >
                        <img alt='list' src="/img/ic_setting_leader_board.svg" />
                        <span>項目変更</span>
                    </div>
                </div>
            </div>
            <div>

                <div className="table-team">
                    <table style={{ position: "relative" }}>
                        <thead id="thead-sticky">
                            <tr>
                                <th className='parent-header' colSpan={'2'} style={{
                                    position: "sticky", top: -1, height: '39px', boxShadow: 'inset -1px -1px 0 #ddd, inset 0 -1px 0 #ddd'
                                }} />
                                {
                                    tableList.headers.map((header, idx) => {
                                        if (!header.children) {
                                            return <th className='parent-header'
                                                key={idx} colSpan={'1'} style={{ borderBottom: '1px solid #ddd', boxShadow: 'inset 0 0px 0 #ddd, inset 0 -1px 0 #ddd', position: "sticky", top: -1 }}>
                                                {idx !== 0 && header.name}
                                            </th>
                                        }
                                        return <th className='parent-header'
                                            key={idx}
                                            colSpan={header.children.length} style={{ position: "sticky", top: -1, boxShadow: 'inset 0 -1px 0 #ddd, inset 0 -1px 0 #ddd', 'text-align': 'center' }}>
                                            {header.name}
                                        </th>
                                    })
                                }
                            </tr>
                            <tr>
                                <th className={'children-header'} style={{ position: "sticky", top: "38px" }}>
                                    <span>順位</span>
                                </th>
                                <th className={'children-header'} style={{ width: 150, textAlign: 'left', position: "sticky", top: "38px", boxShadow: 'inset -1px 0px 0 #ddd, inset 0 0px 0 #ddd' }}>
                                    <span style={{ paddingLeft: 5 }}>
                                        {tableList.key.name}
                                    </span>
                                </th>
                                {
                                    tableList.headers.map((header, index) => {
                                        if (!header.children) {
                                            return <th key={index}
                                                className={'children-header first-children-header'}
                                                style={{ textAlign: 'left', cursor: 'pointer', position: "sticky", top: "37px" }}
                                                onClick={() => onSortList(header)}>
                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                    {sortByFields.activeColumn === header.column && sortByFields[header.column] && <img alt="download" src={'/img/ic_arrow_leader_board.svg'} style={{
                                                        transform: sortByFields[header.column] === 'desc' && 'rotate(180deg)',
                                                    }} />}
                                                    {header.name}
                                                </span>
                                            </th>
                                        }
                                        return header.children.map((item, idx) => {
                                            const isLastItem = (header.children.length - 1) === idx;
                                            const isFirstItem = idx === 0;
                                            return (
                                                <th className={classNames('children-header', isFirstItem && 'first-children-header', isLastItem && 'last-children-header')}
                                                    style={{ textAlign: 'left', cursor: 'pointer', position: "sticky", top: "38px" }}
                                                    key={`${index}__${idx}`}
                                                    onClick={() => onSortList(item)}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                                        {sortByFields.activeColumn === item.column && sortByFields[item.column] && <img alt="download" src={'/img/ic_arrow_leader_board.svg'} style={{
                                                            transform: sortByFields[item.column] === 'desc' && 'rotate(180deg)',
                                                        }} />}
                                                        {item.name}
                                                    </span>
                                                </th>
                                            )
                                        })
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tableList.list.map((value, index) => {
                                    const teamOrPlayer = displayedCustom.isIndividual ? value.player : value.team || {};
                                    const teamName = displayedCustom.isIndividual ? teamOrPlayer.team.team_name : teamOrPlayer.team_name;
                                    const teamId = displayedCustom.isIndividual ? teamOrPlayer.team.id : teamOrPlayer.id;
                                    const name = displayedCustom.isIndividual ? teamOrPlayer.player_name : teamName;
                                    const url = displayedCustom.isIndividual ? `/player/${teamOrPlayer.id}` : `/team-report/${teamOrPlayer.id}`;
                                    return (
                                        <tr key={index}>
                                            <td className='children-body'>
                                                <span>{value.rank}</span>
                                            </td>
                                            <td className='children-body'>
                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                    <img onClick={() => onRedirectDetail('/team-report/' + teamId)} src={detectIconById(teamId)} alt="" style={{ cursor: 'pointer' }} />
                                                    <span onClick={() => onRedirectDetail(url)} style={{ border: 'none', alignItems: 'flex-start', flex: 1, cursor: 'pointer' }}>{name}</span>
                                                </span>
                                            </td>
                                            {
                                                value.data.map((v, idx) => {
                                                    return v.map((item, i) => {
                                                        const isLastItem = i === (v.length - 1);
                                                        const isFirstItem = i === 0;
                                                        return (
                                                            <td style={{ backgroundColor: item.column === sortByFields.activeColumn ? '#fef8e0' : getColorWithRank(item.color) }} key={`children_body_${index}__${idx}_${item.column}`} className={classNames('children-body', isFirstItem && 'first-children-body', isLastItem && 'last-children-body')}>
                                                                <span>{item.value}</span>
                                                            </td>
                                                        )
                                                    })
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {tableList.error && <div className='message-error'>
                        {tableList.error.message}
                    </div>}
                </div>
            </div>
        </div>
    }, [displayedCustom, tableList, sortByFields]);

    useEffect(() => {
        dispatch(getCustomeLeaderBoard());
        dispatch(getYearSeasonRanges());
        dispatch(getReports());
        dispatch(getTeams());
    }, []);

    useEffect(() => {
        if (years.length === 0) return;

        onSelectYear(lodash.head(years));
    }, [years])

    useEffect(() => {
        if (!selectedCustom || !selectedCustom?.isShow) return;
        setDisplayedCustom(selectedCustom);
        setSelectedCustom({
            ...selectedCustom,
            isShow: false,
        });
    }, [selectedCustom]);

    useEffect(() => {
        const sortField = (!sortByFields.activeColumn || !sortByFields[sortByFields.activeColumn]) ? {} : { field: sortByFields.activeColumn, order: (sortByFields[sortByFields.activeColumn] === 'asc') ? 'desc' : 'asc' };
        fetchReport({
            ...displayedCustom,
            sortField: sortField,
        });
    }, [displayedCustom]);

    useEffect(() => {
        if (!isLoadInitStore && tableList.headers.length > 0) {
            tableList.headers.map(item => {
                if (!item.children) {
                    setSortByFields(prevState => ({ ...prevState, [item.column]: item.default_sort }));

                } else {
                    item.children.map(child => {
                        setSortByFields(prevState => ({ ...prevState, [child.column]: child.default_sort }));
                    });
                }
            })
            setIsLoadInitStore(true);
        }
    }, [tableList.headers, isLoadInitStore])

    return <>
        <div className="wrap-leader-board">
            <div className="title-leader-board">
                <h3>リーダーボード
                    <span>
                        <i className="fa fa-question-circle"></i>
                        <div className='tooltips-leader-board'><p>個人・チームで投打の詳細成績を表示し、一覧で比較できます。また、表示項目をカスタマイズしたレポートの作成・保存ができます。</p></div>
                    </span>
                </h3>
                <div>
                    <div style={{ width: 200 }}>
                        <Select
                            value={selectedCustom}
                            classNamePrefix={'leader-board-select'}
                            placeholder={'新規カスタムレポート'}
                            onChange={onSelectCustomReport}
                            options={lodash.concat([{ id: null, name: '新規カスタムレポート', columns: [], filters: [] }], customReports)}
                            getOptionValue={option => option.id}
                            getOptionLabel={option => option.name}
                            components={{
                                DropdownIndicator,
                            }}
                        />
                    </div>
                    <button className='cursor-poiter' onClick={onNewCustomReport}>
                        保存
                    </button>
                    <div onClick={onEditCustomReport} className='cursor-poiter'>
                        <img alt='setting' src='/img/ic_setting_svg.svg' />
                    </div>
                    <div>
                        <CSVLink headers={[titleTable]} data={[
                            largeHeadersCSV,
                            subHeadersCSV,
                            ...listCSV,
                        ]} filename={fileName}>
                            <img alt="download" src='/img/ic_download_svg.svg' />
                            <span>CSVダウンロード</span>
                        </CSVLink>
                    </div>
                </div>
            </div>
            <div className="content-leader-board">
                <div className="options-leader-board">
                    <div className="option-top">
                        <div style={{ minWidth: 370, display: 'flex' }}>
                            <div style={{ marginRight: 10 }}>
                                <button className={classNames(individual && 'active')}
                                    onClick={onChooseIndividual}>
                                    個人
                                </button>
                                <button className={classNames(!individual && 'active')}
                                    onClick={onChooseTeam}>
                                    チーム
                                </button>
                            </div>
                            <div>
                                <button className={classNames(performance === 'pitcher' && 'active')}
                                    onClick={onChoosePitcher}>
                                    投手成績
                                </button>
                                <button className={classNames(performance === 'batter' && 'active')}
                                    onClick={onChooseBatter}>
                                    打撃成績
                                </button>
                                <button className={classNames(performance === 'fielder' && 'active')}
                                    onClick={onChooseFielder}>
                                    守備成績
                                </button>
                                {!individual && <button className={classNames(performance === 'winloss' && 'active')} onClick={onChooseWinloss}>
                                    勝敗・起用
                                </button>}
                            </div>
                        </div>


                        <div style={{ display: 'flex' }}>
                            <div>
                                <Select
                                    value={selectedYear}
                                    classNamePrefix={'leader-board-select'}
                                    placeholder={''}
                                    onChange={onSelectYear}
                                    options={years}
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.id ? `${option.name} 年` : option.name}
                                    components={{
                                        DropdownIndicator,
                                    }}
                                />
                            </div>
                            <div style={{ marginLeft: 10, width: 200 }}>
                                <Dropdown
                                    title={'球団選択'}
                                    options={teams}
                                    selectedValues={selectedTeam}
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.team_name}
                                    onChange={onSelectTeam}
                                />
                            </div>
                        </div>
                        <div style={{ minWidth: 250 }}>
                            <Select
                                value={selectedReport}
                                classNamePrefix={'leader-board-select'}
                                placeholder={'選択してください'}
                                onChange={onSelectReportId}
                                options={reportsFilter}
                                getOptionValue={option => option.id}
                                getOptionLabel={option => option.name}
                                components={{
                                    DropdownIndicator,
                                }}
                            />
                        </div>
                        <div className='tag-teams'>
                            {selectedTeam.map(team => {
                                if (team.team_name === 'NPB' || team.team_name === 'セ・リーグ' || team.team_name === 'パ・リーグ')
                                    return null;
                                return <img src={detectIconById(team.id)} style={{ width: 20, height: 20, marginRight: 5 }} alt="img" />;

                            })}
                        </div>
                        <div onClick={onSelectReport} className='btn-search-leaderboard'>
                            <img alt="filter" src='/img/ic_search_blue.svg' />
                            <span>検索を実行</span>
                        </div>
                    </div>
                    {individual && <KeywordSearch
                        teamIds={selectedCustom.team_ids}
                        players={selectedPlayers}
                        startDate={selectedYear ? selectedYear.start_date : null}
                        endDate={selectedYear ? selectedYear.end_date : null}
                        onChange={onAddPlayer}
                    />}
                </div>
                <div className="table-leader-board">
                    {renderTableContent()}
                </div>
            </div>
        </div>

        {/* cpn item select */}
        {modal === SWAP_ITEM_MODAL && <SwapItemModal
            onCloseModal={onCloseModal}
            leftColumns={columns}
            rightColumns={displayedCustom.columns}
            onConfirm={onConfirmSwapModal}
        />}

        {/* cpn filter */}
        {modal === FILTER_MODAL && <FilterModal
            selectedFilters={displayedCustom.filters}
            onCloseModal={onCloseModal}
            filters={filters}
            onSave={onSaveFilter} />}

        {/* cpn custome add */}
        {modal === NEW_CUSTOM_REPORT_MODAL && <NewCustomReportModal
            errorMessage={customError}
            onCloseModal={onCloseModal}
            onSave={onCustomReportSave}
        />}

        {/* cpn custome update */}
        {modal === EDIT_CUSTOM_REPORT_MODAL && <CustomListModal
            list={customReports}
            onCloseModal={onCloseModal}
            onSave={onSaveListCustom}
        />}
        <Loading show={tableList.loading} />
    </>
}

export default LeaderBoard;